// extracted by mini-css-extract-plugin
export default {"highlight":"App_highlight__LDJnm"};